import { generateApiPath } from "@routes/generatePath";

const pathBase = `/reports/doctors-income/`;

export const doctorIncome = {
  get: () => generateApiPath(pathBase),
};
